import React from 'react';
import { Layout } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "FileText",
    title: "Complete Office Suite",
    description: "Word, Excel, PowerPoint, OneNote"
  },
  {
    iconName: "Mail",
    title: "Outlook",
    description: "Professional email and calendar"
  },
  {
    iconName: "Cloud",
    title: "OneDrive 1TB",
    description: "Secure cloud storage"
  },
  {
    iconName: "Users",
    title: "Microsoft Teams",
    description: "Real-time collaboration"
  },
  {
    iconName: "Share2",
    title: "SharePoint",
    description: "Document sharing"
  },
  {
    iconName: "Shield",
    title: "Advanced Security",
    description: "Data protection"
  }
];

const steps = [
  {
    title: "Sign up on EUROPEAN STUDENT",
    description: "Create your student account in just a few clicks"
  },
  {
    title: "Verify your student status",
    description: "Upload your student card or enrollment certificate"
  },
  {
    title: "Activate your Office 365 license",
    description: "Receive your Microsoft credentials by email within 24 hours"
  }
];

const SoftwarePage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.europeanstudent.org/store/office-365';
  };
  return (
    <div>
      <ServiceHeader
        title="Microsoft Office 365"
        description="The complete Microsoft office suite, free for students."
        icon={<Layout className="w-8 h-8 text-white" />}
        color={colors.accent3}
        imageUrl="https://i.imgur.com/p3fzpQS.png"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.accent3}
            />
          ))}
        </div>

        {/* Included Apps */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Included Applications</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Desktop Applications</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Microsoft Word</li>
                  <li>• Microsoft Excel</li>
                  <li>• Microsoft PowerPoint</li>
                  <li>• Microsoft OneNote</li>
                  <li>• Microsoft Publisher</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Cloud Applications</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Microsoft Teams</li>
                  <li>• Microsoft OneDrive (1TB)</li>
                  <li>• Microsoft SharePoint</li>
                  <li>• Microsoft Stream</li>
                  <li>• Microsoft Forms</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="pt-11">
          <ServiceSteps
                title="How to Benefit"
                steps={steps}
                color={colors.accent3}
                ctaText="Order my Office 365 suite"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default SoftwarePage;